
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { AppCanBoNhanVienService } from 'tnx-frontend-service/dang-ky-kham/services';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
    SwitchControlSchema, DateTimeControlSchema, DropdownControlSchema, OrganizationService, Operator, CoCauToChucControlSchema, CustomControlSchema, CoCauToChucPickerComponent, FormControlBase, EntityMetadataService
} from 'tnx-shared';

@Component({
    selector: 'xac-nhan-form',
    templateUrl: './xac-nhan-form.component.html',
    styleUrls: ['./xac-nhan-form.component.scss'],
    providers: [ComponentContextService],
})
export class XacNhanFormComponent extends DataFormBase implements OnInit {
    boPhanDataSource = [];

    @ViewChild("coCauToChucForm") coCauToChucForm: CoCauToChucPickerComponent;
    idBoPhan: any;
    constructor(
        protected _injector: Injector,
        private _canBoNhanVienService: AppCanBoNhanVienService,
        private _organizationService: OrganizationService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._canBoNhanVienService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'maCongTy',
                label: 'Mã công ty',
                required: true,
                mdWidth: 12
            }),
            new TextControlSchema({
                field: 'maNhanVien',
                label: ' Mã nhân viên',
                mdWidth: 12,
                required: true
            }),
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
        if (data.idCoCauToChuc)
            this.coCauToChucForm.changeDataSource(data.idCoCauToChuc);
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }


    async xacNhan(evt) {
        if (this.model.submitting)
            return;
        this.model.submitting = true;
        const validated = await this.validateForm();
        if (validated) {
            this._canBoNhanVienService.xacNhan(this.model.data.maCongTy, this.model.data.maNhanVien).then(rs => {
                if (rs.success) {
                    this.model.submitting = false;
                    this.onSaved.emit(evt);
                    this._router.navigateByUrl(`/tai-khoan/dang-ky/${rs.data}`);
                } else {
                    this.model.submitting = false;
                    this._notifierService.showBusinessError('Vui lòng kiểm tra lại thông tin xác nhận');
                }
            });
        }
    }

    onBeforeSave() {
        // trước khi lưu
        // console.log(this.model.data.idBoPhan);
        // if (this.idBoPhan)
        //     this.model.data.idBoPhan = this.idBoPhan;
    }
    public async handleFieldValueChange(control: FormControlBase, event?, eventType?, parentModel?, parentPath?, sourceNode?, bubble?) {
        // this.idBoPhan = event;
    }
}

